import React from 'react';
import LoadingView from './LoadingView';

const LoadingContainer = () => {
  return <LoadingView />;
};

export default LoadingContainer;
